import { createSelector } from "@ngrx/store";
import { AppState } from "../../../store/app.state";

export const selectBalanceState = (state: AppState) => state.balance;

export const getBalance = createSelector(
  selectBalanceState,
  (balanceState) => balanceState.balance
);

